import {
    LeadPriorityScore,
    type LeadPriorityValue,
} from "app/pages/sales-intelligence/domain/leads/types/lead-priority";
import LeadScoreAgentContainer from "app/pages/sales-intelligence/modules/lead-scoring-agent/containers/lead-score-agent/LeadScoreAgentContainer";

import leadsSearchTrackingService from "../../../services/tracking/trackingService";
import type { LeadsSearchRow } from "../../../types";
import { getMainCompanyDomainOrDefault } from "../../../utils/rows";

import { StyledBaseCell } from "./styles";

type Props = {
    value: LeadPriorityValue | null;
    record: LeadsSearchRow;
};

export const LeadPriorityCell = ({ value, record }: Props) => {
    const score = value?.score || LeadPriorityScore.Unlock;

    const domain = getMainCompanyDomainOrDefault(record);

    const handleClick = () => {
        leadsSearchTrackingService.trackLeadPriorityClick(score);
    };

    return (
        <StyledBaseCell>
            <LeadScoreAgentContainer
                score={score}
                domain={domain?.domain || ""}
                triggeredRules={value?.triggeredRules}
                onClick={handleClick}
            />
        </StyledBaseCell>
    );
};
